var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jt-data-table',{ref:"jtDataTable",attrs:{"fields":_vm.datatableController.datatable.columns,"singleselect":"","nm-interface":_vm.datatableController.interfaceName}})}
var staticRenderFns = []

export { render, staticRenderFns }